import { UPDATE_STEPS_VISITED } from '../constants/ActionTypes'

export const stepsVisited = function stepVisited(state = [], action) {
  if (UPDATE_STEPS_VISITED !== action.type) {
    return state
  }

  return Object.assign([], state, action.payload)
}
